import dayjs from 'dayjs'
import { DayView, MonthView, WeekView } from '@devexpress/dx-react-scheduler-material-ui'

export function DayViewTimeTableCell(timeTableCellProps: DayView.TimeTableCellProps) {
  const { onDoubleClick, startDate } = timeTableCellProps
  const dbClickable = dayjs(startDate).isSameOrAfter(dayjs())

  return (
    <DayView.TimeTableCell
      {...timeTableCellProps}
      onDoubleClick={dbClickable ? onDoubleClick : undefined}
      style={{
        cursor: dbClickable ? 'pointer' : 'default',
      }}
    />
  )
}

export function WeekViewTimeTableCell(timeTableCellProps: WeekView.TimeTableCellProps) {
  const { onDoubleClick, startDate } = timeTableCellProps
  const dbClickable = dayjs(startDate).isSameOrAfter(dayjs())

  return (
    <WeekView.TimeTableCell
      {...timeTableCellProps}
      onDoubleClick={dbClickable ? onDoubleClick : undefined}
      style={{
        cursor: dbClickable ? 'pointer' : 'default',
      }}
    />
  )
}

export function MonthViewTimeTableCell(timeTableCellProps: MonthView.TimeTableCellProps) {
  const { onDoubleClick, startDate } = timeTableCellProps
  const dbClickable = dayjs(startDate).isSameOrAfter(dayjs())

  return (
    <MonthView.TimeTableCell
      {...timeTableCellProps}
      onDoubleClick={dbClickable ? onDoubleClick : undefined}
      style={{
        cursor: dbClickable ? 'pointer' : 'default',
      }}
    />
  )
}

const TimeTableCell = {
  DayView: DayViewTimeTableCell,
  WeekView: WeekViewTimeTableCell,
  MonthView: MonthViewTimeTableCell,
}

export default TimeTableCell
